<template>
    <div class="main-body">
        <div class="header">
            商家设置
        </div>
        <div class="out">

            <div class="setGov">
                <div :style="contentStyleObj">
                    <template>
                        <el-row class="setBody">
                            <el-col :span="24" class="item" style="text-align:center">
                                <h2></h2>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-card class="box-card card">
                                    <div slot="header" class="clearfix">
                                        <span><i class="el-icon-bank-card" style="margin-right:5px"></i>银行卡</span>
                                        <el-button type="text" icon="el-icon-edit" v-if="bankCard" class="setButton" @click="cardEdit">编辑</el-button>
                                    </div>
                                    <el-col :span="24" style="text-align:center">
                                        <el-card v-if="bankCard" class="box-card card" shadow='hover'>
                                            <div class="bankName">
                                                <i class="el-icon-help" style="margin-right:5px"></i>
                                                <span>{{bankCard.bankName}}</span>
                                            </div>
                                            <div class="bankStatus" v-if="bankCard.status==2">
                                                <span>禁用</span>
                                            </div>
                                            <div style="clear:both"></div>
                                            <div class="bankNumber">
                                                <span>{{bankCard.bankNumber}}</span>
                                            </div>
                                            <div class="bankBranch">
                                                <i class="el-icon-position" style="margin-right:5px"></i>
                                                <span>{{bankCard.bankBranch}}</span>
                                            </div>
                                        </el-card>
                                        <el-card v-else class="box-card card1" shadow='hover' >
                                            <div class="kong" @click="cardAdd">
                                                <i class="el-icon-plus"></i>
                                            </div>
                                        </el-card>
                                    </el-col>
                                </el-card>
                            </el-col>
                        </el-row>
                    </template>
                </div>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false" v-on:getList="getBankInfo"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="showModalEdit=false" v-on:getList="getBankInfo"></Edit>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import Edit from "./Edit";
    import Add from "./Add";

    export default {
        name: "Page",
        data() {
            return {

                tableLoading:false,
                spLoading:false,
                dialogFormVisible:false,
                showModalAdd:false,
                showModalEdit:false,
                GovName:'',
                governmentCode:'',
                listZoneDTO:[],
                level:'',
                roleCode:'',
                roleValue:[],
                lvName:'',
                qzurl:'',
                url:'',
                th:0,
                bankCard:null,
                contentStyleObj: {
                    padding:'20px',
                    backgroundColor:'#fff',
                    overflowY:'auto',
                    height: ''
                },
            }
        },
        created(){
            this.init();
            this.th = this.$store.state.tableHeight;
            this.contentStyleObj.height = this.th +60 +"px";

        },
        components:{
            Add,Edit
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
                this.contentStyleObj.height = this.th+60 +"px";
            },
        },


        methods:{
            init(){
                this.getBankInfo()
            },
            cardAdd(){
                this.showModalAdd=true
                this.$refs.myAdd.init();
            },
            cardEdit(){
                this.showModalEdit=true
                this.$refs.myEdit.init(this.bankCard);
            },
            showModal() {
                this.showModalLevelTree = !this.showModalLevelTree;
            },
            getBankInfo(){
                var _this=this
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"BusinessBank/getByBusinessInfo",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    this.tableLoading=false
                    if(response.data.error == 0){
                        this.bankCard=response.data.data
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    _this.tableLoading=false
                    console.log(error);
                });
            },

        },

    }

</script>


<style lang="scss" scoped>

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        padding-right: 8px;
    }
    .el-button--text{
        font-size: 16px;
    }
    .el-tree-node__content{
        height: auto;
    }
    .sp{
        margin-right: 20px;
    }
    .setBody .el-card__body{
        padding:10px 20px;
    }
    .card{
        margin-bottom: 20px;
        overflow: hidden;
        // border-width:2px;
    }
    .card1{
        margin-bottom: 20px;
        border-width:2px;
        border-style: dashed;
    }
    .bankName{
        float: left;
        font-weight: bold;
        font-size: 20px;
        line-height: 30px;
    }
    .bankNumber{
        font-weight: bold;
        font-size: 28px;
        line-height: 80px;
    }
    .bankStatus{
        float: right;
        width: 200px;
        background: #eee;
        color: #ff4500;
        line-height: 40px;
        margin-right: -75px;
        transform: rotate(45deg);
        // transform: translate(40px);
    }
    .bankBranch{
        float: right;
        color: #999;
        font-size: 16px;
        line-height: 40px;
    }
    .setButton{
        float: right;
        transform: translate(0px, -9px);
    }
    .kong{
        padding: 20px;
        font-size: 40px;
        color: #999;
    }
    .setGov /deep/ .el-dialog{
        border-radius: 10px;
    }
</style>

